import { createContext } from 'react';

import { TimeseriesUnit } from '../../core/types/timeseries.js';
import { TimeseriesDataPointAllTypes } from '../components/displays/shared/types.js';
import {
  WeakMapSeries,
  WeakMapDatapoints,
  TimeseriesSlotProps,
  TimeseriesPerVariant,
} from '../types/timeseries.js';

export interface TimeseriesFilteredData {
  dataPerVariant: TimeseriesPerVariant;
  data: TimeseriesSlotProps[];
  seriesMap: WeakMapSeries;
  datapointsMap: WeakMapDatapoints;
  units: TimeseriesUnit[];
  originalUnits: TimeseriesUnit[];
  allDatapoints: TimeseriesDataPointAllTypes[];
}

export const TimeseriesFilteredDataContext =
  createContext<TimeseriesFilteredData>({
    dataPerVariant: {
      area: [],
      bar: [],
      band: [],
      line: [],
      shapePriority: [],
    },
    data: [],
    units: [],
    seriesMap: new WeakMap(),
    datapointsMap: new WeakMap(),
    originalUnits: [],
    allDatapoints: [],
  });

TimeseriesFilteredDataContext['displayName'] = 'TimeseriesFilteredDataContext';
